(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Mobile: letters bar fixed below header
    var stickyWrap = document.querySelector('.brand_letter_bar_sticky');
    var allBrandsHeading = document.querySelector('.brand_all_content h2');
    var cachedHeaderOffset = 56;
    var stickScrollY = 0;
    var HYSTERESIS = 100;
    function updateHeaderOffset() {
      var header = document.querySelector('store-header .header') || document.querySelector('.header') || document.querySelector('header');
      if (header) {
        var r = header.getBoundingClientRect();
        cachedHeaderOffset = Math.round(r.bottom);
      }
      if (stickyWrap) stickyWrap.style.setProperty('--brand-bar-sticky-top', cachedHeaderOffset + 'px');
    }
    var ticking = false;
    var placeholder = null;
    function ensurePlaceholder() {
      if (!placeholder && stickyWrap.parentNode) {
        placeholder = document.createElement('div');
        placeholder.className = 'brand_letter_bar_placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
      }
      return placeholder;
    }
    function updateStickyBar() {
      if (!stickyWrap || !allBrandsHeading) {
        ticking = false;
        return;
      }
      if (!window.matchMedia('(max-width: 480px)').matches) {
        stickyWrap.classList.remove('brand_letter_bar_fixed');
        if (placeholder && placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
        ticking = false;
        return;
      }
      var scrollY = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      var barRect = stickyWrap.getBoundingClientRect();
      var isFixed = stickyWrap.classList.contains('brand_letter_bar_fixed');
      if (isFixed) {
        if (scrollY < stickScrollY - HYSTERESIS) {
          stickyWrap.classList.remove('brand_letter_bar_fixed');
          if (placeholder && placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
        }
      } else {
        if (barRect.top <= cachedHeaderOffset + 15) {
          stickScrollY = scrollY;
          var barHeight = stickyWrap.offsetHeight;
          var ph = ensurePlaceholder();
          ph.style.height = barHeight + 'px';
          if (!ph.parentNode) stickyWrap.parentNode.insertBefore(ph, stickyWrap.nextSibling);
          stickyWrap.classList.add('brand_letter_bar_fixed');
        }
      }
      ticking = false;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateStickyBar);
    }
    function setupListeners() {
      updateHeaderOffset();
      updateStickyBar();
      var scrollTarget = document.scrollingElement || document.documentElement;
      scrollTarget.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('scroll', onScroll, { passive: true });
      var scrollParent = stickyWrap;
      while (scrollParent && scrollParent !== document.body) {
        var style = window.getComputedStyle(scrollParent);
        var overflow = style.overflowY || style.overflow;
        if (/(auto|scroll|overlay)/.test(overflow)) {
          scrollParent.addEventListener('scroll', onScroll, { passive: true });
          break;
        }
        scrollParent = scrollParent.parentElement;
      }
    }
    if (stickyWrap && allBrandsHeading) {
      setupListeners();
      window.addEventListener('resize', function() {
        updateHeaderOffset();
        onScroll();
      });
      window.addEventListener('load', function() {
        updateHeaderOffset();
        updateStickyBar();
      });
      setTimeout(updateStickyBar, 100);
      setTimeout(updateStickyBar, 500);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-youtube-section"] && !Shopify.designMode) return;
  try {
    

// This function is called when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", function() {
  // Select all small video items and add click event listeners to them
  document.querySelectorAll('.small_video_item img').forEach(function(img) {
    img.addEventListener('click', function() {
      // Extract the YouTube video ID from the image's src attribute
      // Assuming the src is in the format "http://img.youtube.com/vi/{videoID}/maxresdefault.jpg"
      var videoId = this.src.match(/vi\/([^\s/]+)/)[1];
      
      // Construct the new iframe src URL with the extracted video ID
      var newIframeSrc = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&enablejsapi=1';

      // Find the iframe in the first video item and update its src attribute
      var firstVideoIframe = document.querySelector('.first_video_item iframe');
      if(firstVideoIframe) {
        firstVideoIframe.src = newIframeSrc;
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

 document.addEventListener('DOMContentLoaded', function() {
    var links = document.querySelectorAll('.grandchild-nav__item');

    links.forEach(function(link) {
      link.addEventListener('click', function(e) {
        var selectedModelName = e.target.getAttribute('data-title');
        var redirectUrl = 'https://fueled-utv-9628.myshopify.com/pages/make-model-categories';

        // Save the model name to localStorage
        localStorage.setItem('selectedModelName', selectedModelName);

        // Redirect to the new URL
        window.location.href = redirectUrl;
      });
    });
  });

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  var modelName = localStorage.getItem('selectedModelName');
  var modelPlaceholder = document.getElementById('dynamic-model-name-target');
  if (modelName && modelPlaceholder) {
    modelPlaceholder.textContent = modelName;
  }
}); 

  } catch(e) { console.error(e); }
})();
})();
